import React from 'react'
import classNames from 'classnames'

import styles from '@components/tab.module.scss'

const Tab = React.forwardRef(({ onTabSelect, selectedTab, title }, _) => {
  const classes = [styles.tab]
  if (title === selectedTab) {
    classes.push(styles['tab--selected'])
  }

  return (
    <button className={classNames(classes)} onClick={() => onTabSelect(title)}>
      {title}
    </button>
  )
})

export default Tab
